<template>
    <div>
        <div class="container-fluid">
            <div class="row" v-if="companies.length">
                <div class="col-md-5">
                    <div class="filter-box">
                        <div class="custom-input row">
                            <div class="col-md-12"><label class="ep-input-label">Search By</label></div>
                            <div class="col-md-8 pr-0 filter-inputs">
                                <div class="form-group">
                                    <input type="text" class="form-control dash-input" name="name" placeholder="Name" v-model="company_name">
                                    <input type="text" class="form-control dash-input" name="Location" v-model="company_location" placeholder="Location">
                                </div>
                            </div>
                            <div class="col-md-4 pl-0">
                                <div class="form-group filter-actions">
                                    <button type="submit" class="ss-button" @click="filterList()">Search</button>
                                    <button type="submit" class="ss-button not-opened" @click="showFilters($event)"><i class="fas fa-sort-amount-up-alt"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="custom-dropdowm hidden">
                            <div class="sort-flex">
                                <span>Filter By:</span>
                                <select class="dash-input filter-select" name="badge-filter" @change="filterList()">
                                    <option value="">Choose Badge</option>
                                    <option value="New">New</option>
                                    <option value="Hot">Hot</option>
                                    <option value="Verified">Verified</option>
                                    <option value="Trending">Trending</option>
                                    <option value="Featured">Featured</option>
                                    <option value="Promoted">Promoted</option>
                                </select>
                            </div>
                            <div class="sort-flex">
                                <span>Sort By:</span>
                                <ul>
                                    <li class="service-list">
                                        <input type="radio" id="sTwo" value="Approved" @change="filterList()"
                                               name="sort_companies" checked>
                                        <label for="sTwo">Approved</label>
                                    </li>
                                    <li class="service-list">
                                        <input type="radio" id="sOne" value="Pending" @change="filterList()"
                                               name="sort_companies">
                                        <label for="sOne">Pending</label>
                                    </li>
                                    <li class="service-list">
                                        <input type="radio" id="sFour" value="Rejected" @change="filterList()"
                                               name="sort_companies">
                                        <label for="sFour">Rejected</label>
                                    </li>
                                    <li class="service-list">
                                        <input type="radio" id="sThree" value="Invite" @change="filterList()"
                                               name="sort_companies">
                                        <label for="sThree">Invite</label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div ref="infoBox" id="info-box">
                        <div class="college-com-box" v-for="cm in companies" @click.prevent="showData($event)"
                             :id="cm.organization_enc_id">
                            <span v-bind:data-id="cm.organization_enc_id" v-bind:data-status="cm.status">
                                <div class="hidden" v-for="lc in cm.organizationLocations">
                                    {{ lc.name }},
                                </div>
                            </span>
                            <div class="hidden">
                                <span v-bind:data-reviews="cm.organizationReviews.average_rating"
                                      v-if="cm.organizationReviews.average_rating"></span>
                                <span v-else data-reviews="N/A"></span>
                            </div>
                            <div class="dis-abso">
                                <div class="col-md-3 col-sm-3 col-xs-5">
                                    <div class="com-icon mar-left">
                                        <router-link :to="{path: '/profile?slug=' + cm.org_slug}"><img
                                            v-bind:src="cm.logo" alt=""></router-link>
                                    </div>
                                </div>
                                <div class="col-md-9 col-sm-9 col-xs-7">
                                    <div class="college-com-details">
                                        <router-link :to="{path: '/profile?slug=' + cm.org_slug}">
                                            <div class="company-name display-inline-block" v-html="cm.name"></div>
                                            <div v-if="cm.labels.Verified" class="tooltip-main labelImg display-inline-block">
                                                <img src="/images/all-jobs/verified.png"/>
                                                <span class="tooltiptext tooltip-bottom">Verified</span>
                                            </div>
                                        </router-link>
                                        <div class="oppertunities">
                                            {{ cm.industry }}
                                        </div>
                                        <div class="lc-list" v-if="cm.organizationLocations.length">
                                            <div class="location list-data text-overflow-hidden card-locations">
                                                <i class="fas fa-map-marker-alt"> </i>&nbsp;<span v-for="lc in cm.organizationLocations">{{lc.name}}</span>
                                            </div>
                                            <div class="all-location list-data" v-if="cm.organizationLocations.length > 5">
                                                <span v-for="lc in cm.organizationLocations">{{lc.name}}</span>
                                            </div>
                                        </div>
                                        <div class="row margin-top-20">
                                            <!--                                            <div class="col-md-12">-->
                                            <!--                                                <div class="cd-heading">Available Opportunities</div>-->
                                            <!--                                            </div>-->
                                            <div class="col-md-6">
                                                <div v-bind:class="'Jobs av-oppertunity'">Jobs
                                                    <span>{{ cm.jobs_count }}</span>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div v-bind:class="'Internships av-oppertunity'">Internships
                                                    <span>{{ cm.internships_count }}</span>
                                                </div>
                                            </div>
                                            <!--                                    <div class="col-md-4">-->
                                            <!--                                        <div class="av-oppertunity"><span>Profiles:</span> 5 </div>-->
                                            <!--                                    </div>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="jb-tag dropdown p-0" title="Pending"
                                 v-if="cm.college_approvel && cm.college_approvel == 0 && cm.is_deleted != '1'">
                                <!--                                Pending-->
                                <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Pending
                                    <span class="caret"></span></button>
                                <ul class="dropdown-menu">
                                    <li><a href="javascript:;" @click="changeOrgStatus($event, 'Accept')"
                                           :data-key="cm.organization_enc_id" title="Accept">Accept</a></li>
                                    <li><a href="javascript:;" @click="changeOrgStatus($event,'Reject')"
                                           :data-key="cm.organization_enc_id" title="Reject">Reject</a></li>
                                </ul>
                            </div>
                            <div class="jb-tag second" title="Invite to E-Campus"
                                 v-if="cm.status == 'Requested' && cm.is_deleted != '1'">
                                Requested
                            </div>
                            <div class="jb-tag second" title="Invite to E-Campus"
                                 v-else-if="cm.college_approvel == null && cm.is_deleted != '1'">
                                Request to Invite
                            </div>
                            <div class="jb-tag rejected" title="Rejected" v-else-if="cm.is_deleted == '1'">
                                Rejected
                            </div>
                            <div class="jobIocns is-bottom" v-if="cm.labels">
                                <div v-if="cm.labels.Featured" class="tooltip-main">
                                    <img src="/images/all-jobs/featured.png">
                                    <span class="tooltiptext tooltip-bottom">Featured</span>
                                </div>
                                <div v-if="cm.labels.Hot" class="tooltip-main">
                                    <img src="/images/all-jobs/hot.png">
                                    <span class="tooltiptext tooltip-bottom">Hot</span>
                                </div>
                                <div v-if="cm.labels.Promoted" class="tooltip-main">
                                    <img src="/images/all-jobs/promoted.png">
                                    <span class="tooltiptext tooltip-bottom">Promoted</span>
                                </div>
                                <div v-if="cm.labels.Trending" class="tooltip-main">
                                    <img src="/images/all-jobs/trending.png">
                                    <span class="tooltiptext tooltip-bottom">Trending</span>
                                </div>
                                <div class="newJobIcon tooltip-main" v-if="cm.labels.New">
                                    <img src="/images/all-jobs/new-job.png">
                                    <span class="tooltiptext tooltip-bottom">Featured</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-7 height-100 side-details-main">
                    <div v-bind:style="leftColStyles">
                        <div class="detail-box">
                            <!--<div class="filter-box">-->
                            <!--<div class="custom-dropdowm">-->
                            <!--<span>Filters:</span>-->
                            <!--<button type="button" class="filter-btn" @click="coloumFilter"> Location <i-->
                            <!--class="fas fa-caret-down" v-bind:class="{rotatetop: active}"></i></button>-->
                            <!--<div class="coloum-check-loc" v-show="isColomDown">-->
                            <!--<div class="coloum-scroll">-->
                            <!--<div class="coloum-slim">-->
                            <!--<ul>-->
                            <!--<li v-for="column in columns">-->
                            <!--<label class="check-container">-->
                            <!--<input type="checkbox"> {{column}}-->
                            <!--<span class="checkmark"></span>-->
                            <!--</label>-->
                            <!--</li>-->
                            <!--</ul>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->
                            <!--</div>-->
                            <div class="db-two">
                                <div class="top-social" v-if="data_fb || data_ln || data_tw || data_website">
                                    <div>
                                        <a :href="data_fb" class="top-fb" v-if="data_fb" target="_blank">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                    </div>
                                    <div>
                                        <a :href="data_tw" class="top-tw" v-if="data_tw" target="_blank">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                    </div>
                                    <div>
                                        <a :href="data_ln" class="top-in" v-if="data_ln" target="_blank">
                                            <i class="fab fa-linkedin-in"></i>
                                        </a>
                                    </div>
                                    <div>
                                        <a :href="data_website" class="top-web" v-if="data_website" target="_blank">
                                            <i class="fas fa-link"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="jobIocns" v-if="labelsData">
                                    <div v-if="labelsData.Featured" class="tooltip-main">
                                        <img src="/images/all-jobs/featured.png">
                                        <span class="tooltiptext tooltip-bottom">Featured</span>
                                    </div>
                                    <div v-if="labelsData.Hot" class="tooltip-main">
                                        <img src="/images/all-jobs/hot.png">
                                        <span class="tooltiptext tooltip-bottom">Hot</span>
                                    </div>
                                    <div v-if="labelsData.Promoted" class="tooltip-main">
                                        <img src="/images/all-jobs/promoted.png">
                                        <span class="tooltiptext tooltip-bottom">Promoted</span>
                                    </div>
                                    <div v-if="labelsData.Trending" class="tooltip-main">
                                        <img src="/images/all-jobs/trending.png">
                                        <span class="tooltiptext tooltip-bottom">Trending</span>
                                    </div>
                                    <div class="newJobIcon tooltip-main" v-if="labelsData.New">
                                        <img src="/images/all-jobs/new-job.png">
                                        <span class="tooltiptext tooltip-bottom">Featured</span>
                                    </div>
                                </div>
                                <div class="scroll-box">
                                    <div class="scroll-slim">
                                        <div class="com-icon icon-center">
                                            <img v-bind:src="data_logo">
                                        </div>
                                        <div class="company-name margin-top-20">
                                            <router-link :to="{path: '/profile?slug=' + organization_slug}">
                                                <span v-html="data_title"></span>
                                            </router-link>
                                            <div v-if="labelsData.Verified" class="tooltip-main labelImg display-inline-block">
                                                <img src="/images/all-jobs/verified.png"/>
                                                <span class="tooltiptext tooltip-bottom">Verified</span>
                                            </div>
                                        </div>
                                        <div class="location" v-if="data_location"><i class="fas fa-map-marker-alt"></i>
                                            {{ data_location }}
                                        </div>
                                        <div class="about-company">
                                            {{ data_description }}
                                        </div>
                                        <div class="row">
                                            <div class="opp-left">
                                                <div class="col-md-6" v-if="data_website">
                                                    <div class="cd-heading">Website</div>
                                                    <div class="">{{ data_website }}</div>
                                                </div>
                                                <!--                                                <div class="col-md-6" v-if="data_reviews">-->
                                                <!--                                                    <div class="cd-heading">Rating</div>-->
                                                <!--                                                    <div class=""><span class="font-bold">{{data_reviews}}</span> / 5-->
                                                <!--                                                    </div>-->
                                                <!--                                                </div>-->
                                                <div class="col-md-12" v-if="data_jobs || data_internships">
                                                    <div class="cd-heading margin-top-20">Available Opportunities</div>
                                                </div>
                                                <div class="margin-top-20">
                                                    <div class="col-md-4" v-if="data_jobs">
                                                        <div class="av-oppertunity">Jobs: <span> {{ data_jobs }} </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4" v-if="data_internships">
                                                        <div class="av-oppertunity">Interships:
                                                            <span>{{ data_internships }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row" v-if="benefits.length">
                                            <div class="col-md-12">
                                                <div class="cd-heading margin-top-20 text-left">Benefits</div>
                                            </div>
                                            <div class="col-md-3" v-for="bb in benefits">
                                                <div class="benefit-box">
                                                    <div class="bb-icon">
                                                        <img :src="bb.icon">
                                                    </div>
                                                    <div class="bb-text">
                                                        {{ bb.benefit }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="">
                                            <div class="col-md-12 d-flex">
                                                <div class="invite-com-btn"
                                                     v-if="data_status != 'Requested' && data_status == null">
                                                    <button type="button" @click="inviteToCampus($event)"
                                                            :data-key="data_id">Invite To Campus
                                                    </button>
                                                </div>
                                                <div class="invite-com-btn" v-else-if="data_status == 'Requested'">
                                                    <button type="button">Requested</button>
                                                </div>
                                                <div class="view-com-btn">
                                                    <router-link :to="data_slug">View Profile</router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 margin-top-20 text-center"
                                             v-if="data_fb || data_ln || data_tw">
                                            <div class="social-heading">Social Links</div>
                                            <div class="social-buttons">
                                                <a :href="data_fb" target="blank" class="social-margin" v-if="data_fb">
                                                    <div class="social-icon facebook">
                                                        <i class="fab fa-facebook"></i>
                                                    </div>
                                                </a>
                                                <a :href="data_tw" target="blank" class="social-margin" v-if="data_tw">
                                                    <div class="social-icon twitter">
                                                        <i class="fab fa-twitter"></i>
                                                    </div>
                                                </a>
                                                <a :href="data_ln" target="blank" class="social-margin" v-if="data_ln">
                                                    <div class="social-icon linkedin">
                                                        <i class="fab fa-linkedin"></i>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div id="not-found" class="col-md-12 text-center hidden">
                    <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                    <h2 class="no-data-found">No Companies Found</h2>
                </div>
            </div>
            <div class="col-md-12 text-center">
                <div id="loading-list">
                    <div class="loading-list fixed"></div>
                    <div class="loading-list-ring fixed"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import toastr from "../../../public/js/toastr";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
    data: function () {
        return {
            leftColStyles: {},
            isColomDown: false,
            sortBy: "",
            columns: [
                'Ludhiana',
                'Mohali',
                'Pune',
                'Gurgaon',
                'Delhi',
                'Chennai',
                'Hyderabad',
                'Indore',
                'Bangalore',
                'Chandigarh',
                'Goa',
                'Mumbai',
            ],
            companies: [],
            benefits: [],
            data_logo: '',
            data_title: '',
            company_name: '',
            company_location: '',
            data_location: '',
            data_description: '',
            data_id: '',
            data_status: '',
            data_website: '',
            data_slug: '',
            data_reviews: '',
            data_jobs: '',
            data_fb: '',
            data_tw: '',
            data_ln: '',
            data_internships: '',
            organization_slug: '',
            request: false,
            bottom: false,
            loadMore: true,
            page: 1,
            labelsData: '',
            badge_filter: '',
        }
    },
    methods: {
        matchHeight() {
            if (this.$refs.infoBox) {
                var heightString = this.$refs.infoBox.clientHeight + document.getElementsByClassName('filter-box')[0].clientHeight + 'px';
                Vue.set(this.leftColStyles, 'height', heightString);
                $('.coloum-slim').perfectScrollbar();
                $('.scroll-slim').perfectScrollbar();
            }
        },
        // coloumFilter() {
        //     this.isColomDown = !this.isColomDown
        //     this.active = !this.active
        // },
        showData: function (event) {
            var t = this;
            t.benefits = [];
            t.data_reviews = t.data_jobs = t.data_internships = t.data_location = "";
            var rm_elem = document.getElementsByClassName('college-com-box');
            for (var r = 0; r < rm_elem.length; r++) {
                if (rm_elem[r].classList.contains('active')) {
                    rm_elem[r].classList.remove('active');
                }
            }
            var element = event.currentTarget;
            element.classList.add("active");
            var elem_main = element.childNodes;
            t.data_id = elem_main[0].getAttribute('data-id');
            var data = t.$store.getters.getCompaniesById(t.data_id);
            t.benefits = data[0].benefits;
            t.labelsData = data[0].labels;
            t.data_description = data[0].description;
            t.organization_slug = data[0].org_slug;
            t.data_status = elem_main[0].getAttribute('data-status');
            if (elem_main[0].getAttribute('d-status')) {
                t.data_status = 'Requested';
            }
            t.data_website = data[0].website;
            t.data_fb = data[0].facebook;
            t.data_tw = data[0].twitter;
            t.data_ln = data[0].linkedin;
            t.data_reviews = elem_main[1].childNodes[0].getAttribute('data-reviews');
            t.data_logo = data[0].logo
            t.data_slug = element.getElementsByTagName('a')[0].getAttribute('href');
            t.data_title = data[0].name;
            t.data_jobs = data[0].jobs_count;
            t.data_internships = data[0].internships_count;
            t.data_location = elem_main[0].textContent.replace(/,\s*$/, "");
        },
        changeOrgStatus: function (event, status) {
            var t = this;
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            element.parentElement.parentElement.parentElement.classList.remove('p-0');
            element.parentElement.parentElement.parentElement.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/college-index/company-approve`, {
                organization_enc_id: data_key,
                action: status
            }, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    toastr.success('Company ' + status + 'ed Successfully', 'Success');
                } else {
                    toastr.error('Something went wrong. Please try again.', 'Oops!!');
                }
                t.getCompanies();
            })
        },
        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight;

            const bottomOfPage = visible + scrollY >= pageHeight - 200;
            return bottomOfPage;
        },
        inviteToCampus(e) {
            var t = this;
            var element = e.currentTarget
            var data_key = element.getAttribute('data-key');
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/college-index/request-company`, {org_id: data_key}, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    toastr.success('The Request has been sent Successfully', 'Success');
                    t.data_status = 'Requested';
                    var elMain = document.getElementById(data_key);
                    var el = elMain.childNodes[0];
                    var att = document.createAttribute("d-status");
                    att.value = "Requested";
                    el.setAttributeNode(att);
                    elMain.children[3].textContent = 'Requested';
                } else {
                    toastr.error('Some error occurred. Try again later', 'Oops!!');
                }
            });
        },
        addList() {
            if (this.request) {
                this.loadMore = false;
                var url = this.$store.getters.getDomain;

                var a = this;

                var bodyFormData = new FormData();
                bodyFormData.set('page', a.page);
                bodyFormData.set('sort_by', a.sortBy);
                bodyFormData.set('limit', 20);
                bodyFormData.set('company_name', a.company_name);
                bodyFormData.set('company_location', a.company_location);
                bodyFormData.set('filter', a.badge_filter);

                axios({
                    method: 'POST',
                    url: `${url}api/v2/college-index/companies`,
                    headers: requestHeaders(),
                    data: bodyFormData,
                }).then(function (response) {
                    if (response['data']['response']['data']) {
                        for (var i = 0; i < response['data']['response']['data'].length; i++) {
                            a.companies.push(response['data']['response']['data'][i])
                        }
                        if (a.bottomVisible()) {
                            a.page += 1;
                            a.addList()
                        }
                        setTimeout(function () {
                            a.matchHeight();
                        }, 700)
                        a.$store.dispatch("setCompanies", a.companies);
                        a.loadMore = true;
                    } else {
                        a.request = false;
                    }
                })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        },
        filterList() {
            this.sortBy = document.querySelector('input[name="sort_companies"]:checked').value;
            this.badge_filter = document.querySelector('select[name="badge-filter"]').value;
            this.getCompanies();
        },
        getCompanies() {
            if (document.getElementById("loading-list")) {
                var fadeTarget = document.getElementById("loading-list");
                fadeTarget.style.display = "block";
            }

            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/college-index/companies`, {
                limit: 20,
                page: 1,
                sort_by: t.sortBy,
                company_name: t.company_name,
                company_location: t.company_location,
                filter:t.badge_filter
            }, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] === 200) {
                    t.companies = response['data']['response']['data'];
                    t.$store.dispatch("setCompanies", t.companies);
                    setTimeout(function () {
                        if (document.getElementsByClassName('college-com-box')[0]) {
                            document.getElementsByClassName('college-com-box')[0].click();
                        }
                        t.matchHeight();
                    }, 500);
                    t.request = true;
                    t.page = 1;
                } else {
                    if(t.badge_filter){
                        document.querySelector('select[name="badge-filter"]').value = "";
                        alert('No companies Found');
                    }
                    if (document.getElementById("not-found")) {
                        document.getElementById("not-found").classList.remove('hidden');
                    }
                }
                if (document.getElementById("loading-list")) {
                    var fadeTarget = document.getElementById("loading-list");
                    fadeTarget.style.display = "none";
                }
            });
        },
        showFilters(event){
            var element = event.currentTarget;
            if(element.classList.contains('not-opened')){
                element.classList.remove('not-opened');
                document.getElementsByClassName('custom-dropdowm')[0].classList.remove('hidden');
            } else {
                element.classList.add('not-opened');
                document.getElementsByClassName('custom-dropdowm')[0].classList.add('hidden');
            }
        },
    },
    mounted() {
        this.matchHeight();
        this.getCompanies();
    },
    watch: {
        bottom(bottom) {
            if (bottom) {
                this.page += 1;
                this.addList()
            }
        }
    },
    created() {
        window.addEventListener('scroll', () => {
            this.bottom = this.bottomVisible()
        })
    }

}
</script>

<style scoped>
.company-name a{
    color:#000;
}
.scroll-box > .scroll-slim > .com-icon{
    width: 130px;
    height: 130px;
    min-width: 130px;
}
.scroll-box > .scroll-slim > .com-icon img{
    max-width: 90px;
    max-height: 90px;
}
.top-social {
    display: flex;
    position: absolute;
    top: 1px;
    left: 15px;
}

.top-social div {
    padding: 5px 2px;
}
.top-social div a i{
    font-size:18px;
}
.top-fb {
    color: #3b5998;
}

.top-tw {
    color: #00acee;
}

.top-in {
    color: #0e76a8;
}

.top-web {
    color: #ff7803;
}

.top-social div a:hover i {
    transition: .2s ease;
}

.top-social div a:hover i {
    transform: translateY(-2px);
    transition: .2s ease;
}

.tooltip-main .tooltiptext {
    width: auto;
    bottom: -105%;
}

.newJobIcon img {
    max-width: 40px !important;
    margin-right: -6px !important;
}

.scroll-box {
    height: calc(100vh - 150px);
}

.scroll-slim {
    height: calc(100vh - 150px);
    text-align: center !important;
    padding: 10px 20px;
}

.college-com-details > .oppertunities {
    font-size: 14px;
}

.loading-list {
    top: 0;
}

.d-flex {
    display: flex;
    justify-content: center;
}

.d-flex div {
    margin: 0px 10px;
}
.custom-input .form-control.dash-input {
    width: 47%;
    display: inline-block;
    margin: 1%;
}
.custom-input button.ss-button:last-child {
    margin-left: 10px ;
}
.custom-input button.ss-button{
    margin-top: 7px;
}
.not-opened{
    background-color: #fff;
    color: #000;
    border: 1px solid #eee;
}
.loading-list {
    z-index: 9;
}
.card-locations{
    font-size: 13px;
    margin: 10px 0px 5px;
}
.lc-list{
    position: relative;
}
.all-location{
    position: absolute;
    background: #fff;
    max-width: 250px;
    z-index: 9;
    padding: 15px;
    box-shadow: 0px 0px 26px 3px #ddd;
    font-size: 14px;
    border-radius: 8px;
    top: calc(100% + 5px);
    display: none;
}
.lc-list:hover .all-location, .all-location:hover{
    display: block;
}
.all-location:before {
    content: '';
    left: 50%;
    top: -13px;
    position: absolute;
    border-left: 10px solid transparent;
    border-bottom: 15px solid #fff;
    border-right: 10px solid transparent;
    transform: translateX(-50%);
}
.jobIocns.is-bottom{
    bottom: 3px;
    top: auto;
}
.filter-select{
    width: auto;
    margin-left: 15px;
    padding: 0px 10px;
}
@media screen and (max-width: 767px) {
    .college-com-box {
        background: linear-gradient(90deg, #00a0e3 0%, #00a0e3 80px, #fff 80px, #fff 100%) !important;
        transform: scale(1) !important;
    }
    .filter-box{
        padding-right: 20px;
    }
    .filter-inputs{
        padding-right: 15px !Important;
    }
    .filter-inputs div input{
        width: 100% !important;
        margin: 5px 0px !important;
    }
    .filter-actions{
        text-align: center;
    }
}
</style>
